import Path from "../Path";
import PathPlanJumpUpLeft from "../plan/PathPlanJumpUpLeft";
import PathPlanJumpUpRight from "../plan/PathPlanJumpUpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJumpUp1Side1 extends PathTemplatePattern {
    constructor() {
        super([
            '8E',     // ignore   o|p     end
            'S.',     // start    o|p     closed
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 2;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 1; // end tile is 2 columns to the right of start
        const targetRow = start.getTileRow() - 1; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 2, targetCol, targetRow);  // +2: we know the end is at least 2 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpRight(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 1; // end tile is 1 column to the left of start
        const targetRow = start.getTileRow() - 1; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 2, targetCol, targetRow);  // +2: we know the end is at least 2 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpLeft(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJumpUp1Side1';
    }
}